
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"product-library"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.514 3.77L9.098.797a2.447 2.447 0 011.801 0l7.584 2.973a1.47 1.47 0 01.892 1.385v9.69a1.47 1.47 0 01-.89 1.385l-7.582 2.974a2.463 2.463 0 01-1.802 0L1.518 16.23a1.469 1.469 0 01-.893-1.385v-9.69a1.47 1.47 0 01.89-1.385v0zM10 7.794L.92 4.234M10 7.794l9.08-3.56M10 19.375V7.794","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    